import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box } from "@mui/system";
import { useContext, useEffect } from "react";
import { AuthContext } from "../providers/AuthContextProvider";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
var RegisterScreen = function () {
    var authContext = useContext(AuthContext);
    var _a = useParams(), tenantId = _a.tenantId, eventId = _a.eventId;
    var navigate = useNavigate();
    var location = useLocation();
    var _b = useContext(AuthContext), isAuthenticated = _b.isAuthenticated, setTenantEvent = _b.setTenantEvent;
    useEffect(function () {
        if (!isAuthenticated && tenantId && eventId) {
            setTenantEvent(tenantId, eventId, "register");
        }
        else if (authContext.isAuthenticated) {
            navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election-chooser").concat(location.search));
        }
    }, [authContext.isAuthenticated, navigate, isAuthenticated, tenantId, eventId, setTenantEvent]);
    return (_jsx(Box, { children: _jsx(CircularProgress, {}) }));
};
export default RegisterScreen;
